<template>
<div class="container-fluid bg-white">
	<materials-tasks-toolbar title="Materials Apps"></materials-tasks-toolbar>

	<addon-app-tab ui-location="Materials Module"></addon-app-tab>
</div>
</template>
<script type="text/javascript">
import MaterialsTasksToolbar from "./MaterialsTasksToolbar"
import AddonAppTab from "@/components/AddonAppTab"

export default {
	name: "MaterialsApps",
	components: {
		MaterialsTasksToolbar,
		AddonAppTab
	}
}
</script>
